var map = {
	"./abcn.png": "hhPt",
	"./about-future-work-4.jpg": "z2s8",
	"./blog-images/1-INTRODUCING-THE-FLEXIVERSE.png": "4US5",
	"./blog-images/10-4-TECHNOLOGIES-POWERING-THE-FUTURE-OF-WORK.png": "4IuZ",
	"./blog-images/11-THE-MOST-IMPORTANT-SKILL-TO-SUCCEED.png": "ypA/",
	"./blog-images/12-HOW-CRE-CAN-HELP-DRIVE-BUSINESS-RESILIENCE-AND-PERFORMANCE.png": "KNl7",
	"./blog-images/13-PROPTECH-3-POWERED-BY-BLOCKCHAIN-AND-AI.png": "UHHk",
	"./blog-images/14-should-you-focus-on-finding-your-business-purpose.jpg": "+KiX",
	"./blog-images/15-the-shift-towards-employee-owned-hr.jpg": "ZFP7",
	"./blog-images/16-top-10-soft-skills-you-need-to-succeed.jpg": "XCzN",
	"./blog-images/17-are-you-digitally-fit.jpg": "ZY+b",
	"./blog-images/18-ai-in-the-built-environment-4-key-areas-it-will-impact.jpg": "J3AJ",
	"./blog-images/19-top-3-trends-shaping-the-future-of-work.jpg": "TGa7",
	"./blog-images/2-THE-RISE-OF-THE-DIGITAL-WORKPLACE.png": "oMS5",
	"./blog-images/20-the-real-impact-of-automation-on-the-gig-economy.jpg": "yfwr",
	"./blog-images/21-are-smart-buildings-actually-that-intelligent.jpg": "DOwZ",
	"./blog-images/22-proptech-will-be-the-tipping-point-for-the-real-estate-industry.jpg": "ylgs",
	"./blog-images/23-what-is-proptech.jpg": "7N7X",
	"./blog-images/24-WHY-THE-FUTURE-OF-WORK-WILL-PLAY-OUT-DIFFERENTLY-IN-AFRICA.jpg": "9l0u",
	"./blog-images/25-WHY-DIGITAL-TRANSFORMATION-CAN-NO-LONGER-BE-IGNORED.jpg": "i43z",
	"./blog-images/26-HOW-TO-AVOID-EMPLOYEE-TURNOVER.jpg": "45Jo",
	"./blog-images/27-AN-HR-EXPERTS-REACTION-TO-THE-NEW-UK-FLEXIBLE-WORKING-BILL.jpg": "Ympc",
	"./blog-images/28-THE-BOOMING-STATE-OF-THE-PROPTECH-INDUSTRY.jpg": "4xdE",
	"./blog-images/29-THE-TOP-7-SKILLS-FOR-SUCCESS-IN-CRE.jpg": "VuKR",
	"./blog-images/3-HOLOPORTATION.png": "7K1p",
	"./blog-images/30-WHY-BRAND-STORYTELLING-IS-KEY.jpg": "DWv+",
	"./blog-images/31-FLEXIBLE-WORKING-REGULATIONS.jpg": "MtZ0",
	"./blog-images/32-THE-WAR-FOR-TALENT.jpg": "lAqz",
	"./blog-images/33-HOW-TO-ATTRACT-GEN-Z-TO-THE-WORKPLACE.jpg": "sEM6",
	"./blog-images/34-PURPOSE-IS-THE-NEW-BLACK.jpg": "JnsU",
	"./blog-images/35-WHAT-MAKES-US-HUMAN-WILL-MAKE-US-EMPLOYABLE-IN-THE-FUTURE.jpg": "ONbc",
	"./blog-images/36-THE-FUTURE-OF-WORK-IS-ABOUT-ONE-THING-FLEXIBILITY.jpg": "XTp4",
	"./blog-images/37-should-your-organization-offer-and-pay-for-retraining-opportunities.jpg": "sJ66",
	"./blog-images/38-the-future-of-work-needs-human-values-skills-and-communities.jpg": "74RI",
	"./blog-images/39-which-eu-countries-are-best-prepared-for-the-future-of-work.jpg": "zsVr",
	"./blog-images/4-FUTURE-WORKPLACE-DESIGN.png": "s1hN",
	"./blog-images/40-future-of-work-how-job-crafting-will-change-the-way-we-work.jpg": "5Px/",
	"./blog-images/41-future-of-work-flexibility-is-the-key-ingredient-to-a-happy-workforce.jpg": "upN/",
	"./blog-images/42-future-of-work-why-companies-should-focus-on-employee-engagement.jpg": "5zyo",
	"./blog-images/5-PROPTECH-TRENDS.png": "v+yn",
	"./blog-images/6-TECHNOLOGIES-WORKPLACE.png": "uaEL",
	"./blog-images/7-HUMAN-EXPERIENCE-DESIGN.png": "Xe6z",
	"./blog-images/8-FOSTERING-COMMUNITY.png": "OJOa",
	"./blog-images/9-UNDERSTANDING-THE-FUTURE-OF-WORK.png": "cLQ4",
	"./blog-images/HOLOPORTATION_video.png": "E1/c",
	"./blueish-bg.png": "+nAR",
	"./fowf-advisor-1.jpg": "tyUt",
	"./fowf-advisor-2.jpg": "GJPS",
	"./fowf-advisor-3.jpg": "K57q",
	"./fowf-chris-color.jpg": "8ROb",
	"./fowf-david-color.jpg": "CVni",
	"./fowf-frank-color.jpg": "0mPH",
	"./fowf-ian-color.jpg": "WdIp",
	"./fowf-icon-original.png": "iNUX",
	"./fowf-icon.png": "ThiO",
	"./fowf-jonathan-color.jpg": "/0BK",
	"./fowf-michael-color.jpg": "LenA",
	"./fowf-mike-color.jpg": "t6VL",
	"./fowf-team-web.jpg": "X6w9",
	"./fowf-team-web1.jpg": "SAi4",
	"./fowf-toshi-color.jpg": "hi+H",
	"./future-work-home-1.jpg": "zhfM",
	"./future-work-home-2.jpg": "g8nb",
	"./future-work-home-3.jpg": "zgIz",
	"./sprites.svg": "GRX8",
	"./tour.png": "xx/C"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2qD";